import PropTypes from 'prop-types';
import Ad from '../Ad/Ad';
import { AdSizes } from '../Ad/AdSizes';

export default function RightRail(props) {
	const {
		className = '', htmlId = 'rightrail-ad', wrapperClass = '', pos = '1',
	} = props;

	return (
		<aside className={`right-rail ${className}`}>
			<Ad
				sizes={{
					'xs sm md': AdSizes.HIDDEN,
					'lg xl xxl': AdSizes.BIG_BOX_COMBO,
				}}
				htmlId={htmlId}
				wrapperClass={`ad-wrapper right-rail-ad-wrapper hide-mobile hide-tablet ${wrapperClass}`}
				pos={pos}
			/>
		</aside>
	);
}

RightRail.propTypes = {
	className: PropTypes.string,
	htmlId: PropTypes.string,
	wrapperClass: PropTypes.string,
	pos: PropTypes.string,
};
